import { render, staticRenderFns } from "./generic-modal.html?vue&type=template&id=380dbb60&scoped=true&"
import script from "./generic-modal.js?vue&type=script&lang=js&"
export * from "./generic-modal.js?vue&type=script&lang=js&"
import style0 from "./generic-modal.scss?vue&type=style&index=0&id=380dbb60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380dbb60",
  null
  
)

export default component.exports